import { RouteRecordRaw } from 'vue-router';
import { IRouteMeta, ResolveParams } from '@/core/models/routing';
import { AppCoreEnums } from '@/core/shared/enums';
import { AppPermissions } from '@/shared/permissions';
import useCoreUtils from '@/core/composable/use-core-utils';
import { KIEngine } from '@/stores/ki-engines/models';
import { useKIEnginesStore } from '@/stores';

const ROUTE_KI_ENGINES_ROOT = 'ki-engines-root';
const ROUTE_KI_ENGINES = 'ki-engines';
const ROUTE_KI_ENGINE_DETAILS = 'ki-engine-details';
const ROUTE_KI_ENGINE_INDEX_SEARCH = 'ki-engine-index-search';
const { propertyOf } = useCoreUtils();

const kiEngineRoutes: RouteRecordRaw = {
  name: ROUTE_KI_ENGINES_ROOT,
  path: ROUTE_KI_ENGINES,
  component: () => import('src/core/containers/empty-container.vue'),
  meta: <IRouteMeta>{
    containerType: AppCoreEnums.ContainerType.EmptyContainer,
    resolve: async (resolveParams: ResolveParams) => {
      const { useUsersStore } = await import('@/stores');
      return useUsersStore().loadAllUsersLite();
    },
    permissions: {
      readPermission: AppPermissions.KIEngineRead,
      writePermission: AppPermissions.KIEngineWrite,
      deletePermission: AppPermissions.KIEngineDelete,
    },
  },
  redirect: { name: ROUTE_KI_ENGINES },
  children: [
    {
      name: ROUTE_KI_ENGINES,
      path: 'list',
      component: () => import('src/pages/ki-engines/ki-engines-page.vue'),
      meta: <IRouteMeta>{
        collapsibleTableTitleField: propertyOf<KIEngine>('name'),
        resolve: async (resolveParams: ResolveParams) => {
          const { useKIEnginesStore } = await import('@/stores');
          return useKIEnginesStore().loadkIEngines(resolveParams);
        },
        containerType: AppCoreEnums.ContainerType.CollapsibleTableContainer,
      },
      children: [
        {
          name: ROUTE_KI_ENGINE_DETAILS,
          path: ':id',
          component: () => import('src/pages/ki-engines/ki-engine-search-page.vue'),
          meta: <IRouteMeta>{
            containerType: AppCoreEnums.ContainerType.CollapsibleContainer,
            resolve: async (resolveParams: ResolveParams) => {
              const { useKIEnginesStore } = await import('@/stores');
              return Promise.all([
                useKIEnginesStore().loadkIEngineById(resolveParams),
                useKIEnginesStore().loadIndexSearchedDocumentsCount(resolveParams),
              ]);
            },
          },
          redirect: { name: ROUTE_KI_ENGINE_INDEX_SEARCH },
          children: [
            {
              name: ROUTE_KI_ENGINE_INDEX_SEARCH,
              path: 'search',
              component: () => import('src/pages/ki-engines/ki-engine-search-results.vue'),
              meta: <IRouteMeta>{
                containerType: AppCoreEnums.ContainerType.ListContainer,
                formModel: () => useKIEnginesStore().get('kiEngineProperties'),
                resolve: async (resolveParams: ResolveParams) => {
                  const { useKIEnginesStore } = await import('@/stores');
                  return useKIEnginesStore().loadIndexDocuments(resolveParams);
                },
              },
            },
          ],
        },
      ],
    },
  ],
};

export { kiEngineRoutes, ROUTE_KI_ENGINES, ROUTE_KI_ENGINES_ROOT, ROUTE_KI_ENGINE_DETAILS, ROUTE_KI_ENGINE_INDEX_SEARCH };
